import styled, { keyframes } from 'styled-components';
import { ChevronDown } from 'lucide-react';
// Card and theme removed - home module deleted
export const Card = styled.div``;
export const theme = {
  colors: {
    text: '#e5e7eb', // Default text color
  },
};

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const blink = keyframes`
  0%, 100% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }
`;

export const HeaderShell = styled.div`
  position: sticky;
  top: 0;
  z-index: 10000;
  backdrop-filter: saturate(1.1) blur(10px);
  background: transparent;
  color: ${theme.colors.text};
`;

export const Header = styled.header`
  width: 100%;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${({ blurIntensity }) => `rgba(15, 23, 42, ${0.2 + blurIntensity * 0})`};
  backdrop-filter: ${({ blurIntensity }) => `blur(${10 + blurIntensity * 10}px)`};
  transition: backdrop-filter 0.4s ease, background 0.4s ease;
  animation: ${fadeIn} 0.5s ease forwards;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Logo = styled(Card)`
  padding: 0.5rem 1rem;
  font-weight: 900;
  font-size: 1.3rem;
  color: ${theme.colors.text};
`;

export const Center = styled.nav`
  flex: 1;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ButtonBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const ButtonWrapper = styled.div`
  position: relative;
`;

export const Button = styled.button`
  background: ${({ active }) => (active ? 'rgba(0, 247, 210, 0.15)' : 'rgba(15, 23, 42, 0.6)')};
  border: 1px solid ${({ active }) => (active ? 'rgba(0, 247, 210, 0.3)' : 'rgba(31, 41, 55, 0.5)')};
  color: #e5e7eb;
  font-weight: 600;
  padding: 12px 18px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  width: 100%;
  text-align: left;
  margin: 0 4px;

  &:hover {
    background: rgba(15, 23, 42, 0.8);
    border-color: rgba(0, 247, 210, 0.3);
    transform: translateX(4px);
  }

  @media (max-width: 500px) {
    font-size: 13px;
    padding: 10px 16px;
  }
`;

export const DropdownIcon = styled(ChevronDown)`
  transition: transform 0.2s ease;
  ${({ $expanded }) => $expanded && 'transform: rotate(180deg);'}
`;

export const Submenu = styled.div`
  position: absolute;
  top: 44px;
  left: 0;
  min-width: 220px;
  background: rgba(15, 23, 42, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  animation: ${fadeIn} 0.2s ease both;
  box-shadow: 0 22px 45px rgba(0, 0, 0, 0.45);
  z-index: 205;
`;

export const SubmenuGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SubmenuHeading = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
  color: rgba(224, 231, 255, 0.68);
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const SubItem = styled.button`
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  color: #e5e7eb;
  text-align: left;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background 0.25s ease, transform 0.25s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    transform: translateX(4px);
  }
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
`;

export const IconButton = styled.button`
  position: relative;
  height: 36px;
  width: 36px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: #e5e7eb;
  cursor: pointer;
  transition: all 0.25s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }

  &:active {
    transform: scale(0.95);
  }

  &.hide-on-mobile {
    @media (max-width: 768px) {
      display: none;
    }
  }
`;

export const AlertBadge = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ef4444;
  color: white;
  font-size: 0.6rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 8px #ef4444;
  animation: ${blink} 1.5s infinite;
`;

export const BurgerButton = styled(IconButton)`
  display: none;

  @media (max-width: 768px) {
    display: grid;
  }
`;

export const MobileMenu = styled.div`
  position: absolute;
  top: 67px;
  left: 0;
  width: 100%;
  background: #0f172a;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  padding: 16px;
  border-bottom: 1px solid rgba(31, 41, 55, 0.5);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  animation: ${fadeIn} 0.3s ease both;
  max-height: calc(100vh - 67px);
  overflow-y: auto;
`;

export const QuickActionWrapper = styled.div`
  display: flex;
  gap: 10px;
  padding: 0 4px 12px;
  border-bottom: 1px solid rgba(31, 41, 55, 0.5);
  margin-bottom: 8px;
`;

export const QuickActionButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(31, 41, 55, 0.5);
  border-radius: 12px;
  color: #e5e7eb;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background: rgba(15, 23, 42, 0.8);
    border-color: rgba(0, 247, 210, 0.3);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    color: #00f7d2;
  }
`;

export const QuickActionBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fb7185;
  color: white;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(15, 23, 42, 0.98);
  box-shadow: 0 0 8px rgba(251, 113, 133, 0.5);
`;

export const MobileSubmenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 0 18px 8px;
`;

export const MobileSubmenuGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const MobileSubmenuHeading = styled.div`
  font-size: 0.78rem;
  font-weight: 700;
  color: rgba(224, 231, 255, 0.72);
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

